import { Dashboard } from '../Pages/Dashboard/Dashboard';
import {
    PrimaryContactInformation,
    BusinessCompetitionInsights,
    BusinessInfo,
    AddOwner,
    AdvanceBusinessDetails,
    BusinessCommitment,
    Verification,
    PreviewApplication,
    CropAcreages,
    CreditLimitRiskMeasureTag,
    ApproveApplicationSH,
    NewDealerCard,
    KYC,
} from '../Pages/Registeration';
import {
    ApproveSHCard,
    PipelineSHCard,
    RejectSHCard,
    MeetingHistorySHCard, OpenMeetingSHCard, OrderSummarySHCard, BirthdaySHCard, MarriageSHCard, WorkSHCard, DealerActiveInactiveSHCard
} from '../Components/ListCard';
import {
    ApprovedAppTable,
    PipelineTable,
    RejectedAppTable,
    MeetingHistoryFTD, OpenMeetingFTD, OrderSummaryTableFTD, DealerBdayTable, DealerWAnnivTable, DealerMAnnivTable, DealerListActiveTable
} from '../Components/Tables';
import { SetGoal } from '../Pages/Settings';
import OpenOrders from '../Pages/CNF/OpenOrders/OpenOrders';
import FulfilledOrders from '../Pages/CNF/FulfilledOrders/FulfilledOrders';
import {
    ManageDealer,
    ManageUser,
    ProductList,
    ChangeTerritoryManager,
    Holidays,
    AssignDealerCode,
    ChangeManager,
    LoginDetails,
    ManageTerritory,
} from '../Pages/Admin';
import CNFDashboard from '../Pages/CNF/CNFDashboard/CNFDashboard';
import { SurveyForm } from '../Pages/Survey';
import { Travel } from '../Pages/Travel/Travel';
import Contact from '../Components/Contact/Contact';
import { Permissions } from '../constants/Permissions';

export const mainPrivateRoutesArr = [
    // {
    //   path: '/agrocel',
    //   component: Dashboard,
    // },
    {
        path: '/agrocel/dashboard',
        component: Dashboard,
        permissions: [Permissions.DASHBOARD],
    },
    // {
    //   path: '/pages',
    //   component: Registration,
    // },
    {
        path: '/pages/new-dealer/:id?',
        component: NewDealerCard,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/basic-business-info/:id?',
        component: BusinessInfo,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/add-owner/:id?',
        component: AddOwner,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/primary-contact-info/:id?',
        component: PrimaryContactInformation,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/advance-business-details/:id?',
        component: AdvanceBusinessDetails,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/business-competition-insights/:id?',
        component: BusinessCompetitionInsights,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/business-commitment/:id?',
        component: BusinessCommitment,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/verify-n-submit/:id?',
        component: Verification,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/pipeline/:id?',
        component: PipelineTable,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/approved-app/:id?',
        component: ApprovedAppTable,
        permissions: [Permissions.APPROVED_APP],
    },
    {
        path: '/pages/rejected-app/:id?',
        component: RejectedAppTable,
        permissions: [Permissions.REJECTED_APP],
    },
    {
        path: '/pages/pipeline-summary/:id?',
        component: PipelineSHCard,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/approved-app-summary/:id?',
        component: ApproveSHCard,
        permissions: [Permissions.APPROVED_APP],
    },
    {
        path: '/pages/rejected-app-summary/:id?',
        component: RejectSHCard,
        permissions: [Permissions.REJECTED_APP],
    },
    {
        path: '/pages/preview-app/:id?',
        component: PreviewApplication,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/crop-acreages/:id?',
        component: CropAcreages,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/credit-limit-n-risk-measure-tag/:id?',
        component: CreditLimitRiskMeasureTag,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/approve-application-by-sh/:id?',
        component: ApproveApplicationSH,
        permissions: [Permissions.PIPELINE],
    },
    {
        path: '/pages/kyc/:id?',
        component: KYC,
        permissions: [Permissions.DEALER_LIST],
    },
    // {
    //   path: '/meeting',
    //   component: DealerMeetings,
    // },
    {
        path: `/meeting/open-meeting-user-list/:id?`,
        component: OpenMeetingSHCard,
        permissions: [Permissions.OPEN_MEETING]
    },
    {
        path: `/meeting/open-meeting/:pagetype?/:id?`,
        component: OpenMeetingFTD,
        permissions: [Permissions.OPEN_MEETING]
    },
    {
        path: `/meeting/meeting-history-user-list/:id?`,
        component: MeetingHistorySHCard,
        permissions: [Permissions.MEETING_HISTORY]
    },
    {
        path: "/meeting/meeting-history/:pagetype?/:id?",
        component: MeetingHistoryFTD,
        permissions: [Permissions.MEETING_HISTORY]

    },
    // {
    //   path: '/order',
    //   component: Summary,
    // },
    {
        path: "/order/order-summary-user-list/:id?",
        component: OrderSummarySHCard,
        permissions: [Permissions.ORDER_SUMMARY]
    },
    {
        path: "/order/order-summary/:pagetype?/:id?",
        component: OrderSummaryTableFTD,
        permissions: [Permissions.ORDER_SUMMARY]
    },
    // {
    //   path: '/dealer',
    //   component: DealerEngagement,
    // },
    {
        path: "/dealer/birth-day/:id?",
        component: DealerBdayTable,
        permissions: [Permissions.DEALER_BIRTHDAY]
    },
    {
        path: "/dealer/birth-day-summary/:id?",
        component: BirthdaySHCard,
        permissions: [Permissions.DEALER_BIRTHDAY]
    },
    {
        path: "/dealer/work-anniversary/:id?",
        component: DealerWAnnivTable,
        permissions: [Permissions.DEALER_WORK_ANNIVERSARY]
    },
    {
        path: "/dealer/work-anniversary-summary/:id?",
        component: WorkSHCard,
        permissions: [Permissions.DEALER_WORK_ANNIVERSARY]
    },
    {
        path: "/dealer/m-anniversary/:id?",
        component: DealerMAnnivTable,
        permissions: [Permissions.DEALER_MARRIAGE_ANNIVERSARY]
    },
    {
        path: "/dealer/m-anniversary-summary/:id?",
        component: MarriageSHCard,
        permissions: [Permissions.DEALER_MARRIAGE_ANNIVERSARY]
    },
    // {
    //   path: '/list',
    //   component: DealerList,
    // },
    {
        path: "/list/dealer-user-list/:id?",
        component: DealerActiveInactiveSHCard,
        permissions: [Permissions.DEALER_LIST]
    },
    {
        path: "/list/dealer-list/:pagetype?/:id?",
        component: DealerListActiveTable,
        permissions: [Permissions.DEALER_LIST]
    },
    // {
    //   path: '/admin',
    //   component: Admin,
    // },
    {
        path: '/admin/manage-dealer',
        component: ManageDealer,
        permissions: [Permissions.ADMIN_MANAGE_DEALER],
    },
    {
        path: '/admin/login-report',
        component: LoginDetails,
        permissions: [Permissions.LOGIN_REPORT],
    },
    {
        path: '/admin/assign-dealer-code',
        component: AssignDealerCode,
        permissions: [Permissions.ADMIN_ASSIGN_DEALER_CODE],
    },
    {
        path: '/admin/manage-user',
        component: ManageUser,
        permissions: [Permissions.ADMIN_MANAGE_USER],
    },
    {
        path: '/admin/product-list',
        component: ProductList,
        permissions: [Permissions.ADMIN_PRODUCT_LISTS],
    },
    {
        path: '/admin/assign-territories',
        component: ChangeTerritoryManager,
        permissions: [Permissions.ADMIN_ASSIGN_TERRITORIES],
    },
    {
        path: '/admin/manage-territories',
        component: ManageTerritory,
        permissions: [Permissions.ADMIN_MANAGE_TERRITORIES],
    },
    {
        path: '/admin/holidays',
        component: Holidays,
        permissions: [Permissions.ADMIN_HOLIDAYS],
    },
    {
        path: '/admin/change-manager',
        component: ChangeManager,
        permissions: [Permissions.ADMIN_CHANGE_MANAGER],
    },
    // CNF User
    {
        path: '/admin/cnf-dashboard',
        component: CNFDashboard,
        permissions: [Permissions.CNF_DASHBOARD],
    },
    // {
    //   path: '/goals',
    //   component: Goals,
    // },
    {
        path: '/goals/set-goal',
        component: SetGoal,
        permissions: [Permissions.SET_GOAL],
    },
    // {
    //   path: '/cnf',
    //   component: CNF,
    // },
    {
        path: '/cnf/cnf-dashboard',
        component: CNFDashboard,
        permissions: [Permissions.CNF_DASHBOARD],
    },
    {
        path: '/cnf/open-orders',
        component: OpenOrders,
        permissions: [Permissions.CNF_DASHBOARD],
    },
    {
        path: '/cnf/fulfilled-orders',
        component: FulfilledOrders,
        permissions: [Permissions.CNF_DASHBOARD],
    },
    // {
    //   path: '/survey',
    //   component: Survey,
    // },
    {
        path: `/survey/survey-form`,
        component: SurveyForm,
        permissions: [Permissions.SURVEY_FORM],
    },
    // {
    //   path: '/travel',
    //   component: Travel,
    // },
    {
        path: '/travel',
        component: Travel,
        permissions: [Permissions.DISTANCE_TRAVEL],
    },
    {
        path: '/settings/contact-us',
        component: Contact,
        permissions: [Permissions.CONTACT_US]
    }
]